<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import FullScreen from '../ol/control/FullScreen';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        props: {
        },
        data()
        {
            return {
                idPanel: 'fullscreen',
                className: 'ol-fullscreen',
            }
        },
        computed: {

        },
        methods: {
            addButtonMap: function(_map){
                // FullScreen
                let panel = _map.getPanel(this.posBtnMap);
                if(panel) {
                    let target = panel.element;
                    let label = document.createElement('img');
                    label.setAttribute('src', this.assetsPathTheme('/map/fullscreen.svg'));
                    label.setAttribute('alt', this.title);
                    let ctrl = new FullScreen({
                        tipLabel: this.title,
                        className: _map.getControlClassName(this.orderClassName),
                        source: _map.getTarget() + '-fullscreen',
                        target: target,
                        label: label,
                    });
                    _map.addControlOL(ctrl);
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                        let el = $(ctrl.element); if(el) el.hide()
                    });
                    this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                        let el = $(ctrl.element); if(el) el.show()
                    });
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>

<style lang="scss" scoped>
</style>